export default __webpack_public_path__ + "static/media/program2019.46dc1c80.pdf";